import { Injectable } from '@angular/core';
import { NAV_GROUPS, WORKFLOW_STEPS } from '../config/navigation.config';
import type { NavigationGroup, NavigationItem, WorkflowStep } from '../models/navigation.model';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  readonly groups: NavigationGroup[] = NAV_GROUPS;
  readonly steps: WorkflowStep[] = WORKFLOW_STEPS;

  flatten(): NavigationItem[] {
    return NAV_GROUPS.flatMap((g) => g.items);
  }

  findByRoute(route: string): NavigationItem | undefined {
    return this.flatten().find((i) => i.route === route);
  }

  findByNavId(navId: string): NavigationItem | undefined {
    return this.flatten().find((i) => i.id === navId);
  }

  stepForNavId(navId: string): WorkflowStep | undefined {
    return WORKFLOW_STEPS.find((s) => s.navIds.includes(navId));
  }

  stepIndexForNavId(navId: string): number {
    return WORKFLOW_STEPS.findIndex((s) => s.navIds.includes(navId));
  }

  groupForNavId(navId: string): NavigationGroup | undefined {
    return NAV_GROUPS.find((g) => g.items.some((i) => i.id === navId));
  }
}
